









































































































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, MTablehelper, confirmationHelper } from '@/mixins';
import {
  BaseResultModel,
  Dictionary,
  Configuration,
  ScriveTemplateSigningPartyFieldSearchModel,
  ScriveTemplateSigningPartyFieldModel,
  ScriveTemplateSigningPartyFieldPlacementModel,
  ScriveTemplateSigningPartyFieldCreateUpdateModel
} from '@/types';
import { TableStateFields } from '@/types/constants/TableConstants';
import { RouteRegEx, ScriveSigningPartyFieldType } from '@/types/enums';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreFormGroup from '@/components/shared/MStoreFormGroup.vue';
import MStoreFormRadioButtonGroup from '@/components/shared/MStoreFormRadioButtonGroup.vue';

export default Vue.extend({
  name: 'ScriveEditSigningPartyField',
  mixins: [FormFieldValidation, RouteHelpers, MTablehelper, confirmationHelper],
  data() {
    return {
      isLoading: true,
      templateSigningPartyField: {} as ScriveTemplateSigningPartyFieldModel,
      fields: [
        {
          pageNumber: {
            label: 'Page Number',
            sortable: true
          }
        },
        {
          relativeXPosition: {
            label: 'Relative X Position',
            sortable: true
          }
        },
        {
          relativeYPosition: {
            label: 'Relative Y Position',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      items: [] as ScriveTemplateSigningPartyFieldPlacementModel[],
      submitIsLoading: false,
      hasError: false,
      errorMessage: '',
      tableStateKey: MTablehelper.Constants.TableStoreKeys.ScriveEditSigningPartyField,
      placementsClass: ''
    };
  },
  methods: {
    async initialise(this: any) {
      this.resetViewState();
      await this.getTemplateSigningPartyFieldConfigurationAsync();
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.ScriveSigningPartyFieldPlacements);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        this.submitIsLoading = true;

        const result: BaseResultModel = await ScriveConfigurationService.updateSigningPartyFieldAsync(this.templateSigningPartyField.id, {
          templateSigningPartyId: this.signingPartyId,
          description: this.templateSigningPartyField.description,
          fieldName: this.templateSigningPartyField.fieldName,
          type: this.templateSigningPartyField.type
        } as ScriveTemplateSigningPartyFieldCreateUpdateModel);

        if (result.hasNotification && !result.showToast) {
          this.addFormValidationError(result.notification);
          this.submitIsLoading = false;
          return;
        }

        this.submitIsLoading = false;
        SnotifyConfiguration.showSuccess('Signing party field updated successfully.');
      } catch (error) {
        this.$log('Error updating signing party field', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getTemplateSigningPartyFieldConfigurationAsync(this: any) {
      this.resetFormValidation();
      this.isLoading = true;
      try {
        // tslint:disable-next-line:max-line-length
        this.templateSigningPartyField = await ScriveConfigurationService.getTemplateSigningPartyFieldConfigurationAsync({
          templateSigningPartyFieldId: this.signingPartyFieldId
        } as ScriveTemplateSigningPartyFieldSearchModel);
        this.items = this.templateSigningPartyField.templateSigningPartyFieldPlacements;
      } catch (error) {
        this.templateSigningPartyField = {} as ScriveTemplateSigningPartyFieldModel;
        this.$log('Error getting signing party field');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToEditSigningParty();
    },
    navigateToEditSigningParty(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.id = this.signingPartyId;
      this.$router.push({
        name: Configuration.Scrive.SigningParty.Edit.name,
        params: param
      });
    },
    async onDeleteSigningPartyFieldPlacementAsync(this: any, id: number) {
      const result = await this.hasDeleteConfirmedAsync(this.$bvModal, 'Are you sure you want to delete this field placement?');
      if (result) {
        this.isLoading = true;
        try {
          await ScriveConfigurationService.deleteSigningPartyFieldPlacementAsync(id);
          SnotifyConfiguration.showSuccess('Field placement deleted successfully.');
          await this.getTemplateSigningPartyFieldConfigurationAsync();
        } catch (error) {
          this.$log('Error deleting field placement');
        } finally {
          this.isLoading = false;
        }
      }
    },
    navigateToAddFieldPlacement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.signingPartyId;
      param.signingPartyFieldId = this.signingPartyFieldId;
      this.$router.push({
        name: Configuration.Scrive.SigningPartyFieldPlacement.Add.name,
        params: param
      });
    },
    navigateToEditFieldPlacement(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.signingPartyId;
      param.signingPartyFieldId = this.signingPartyFieldId;
      param.id = id;
      this.$router.push({
        name: Configuration.Scrive.SigningPartyFieldPlacement.Edit.name,
        params: param
      });
    },
    navigateToTemplateTabManagement(this: any) {
      this.navigateToRoute(Configuration.Scrive.Template.Management.name, this.documentTypeId);
    }
  },
  computed: {
    tableStateFields() {
      return TableStateFields;
    },
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    signingPartyId(): number {
      return Number(this.$route.params.signingPartyId);
    },
    signingPartyFieldId(): number {
      return Number(this.$route.params.id);
    },
    headerText(this: any) {
      return this.templateSigningPartyField?.fieldName ? `Edit Signing Party Field (${this.templateSigningPartyField.fieldName})` : 'Edit Signing Party Field';
    },
    templateSigningPartyFieldType: {
      get(this: any) {
        return (this.templateSigningPartyField as ScriveTemplateSigningPartyFieldModel).type?.toString();
      },
      set(value: number) {
        (this.templateSigningPartyField as ScriveTemplateSigningPartyFieldModel).type = value.toString() as ScriveSigningPartyFieldType;
      }
    }
  },
  mounted(this: any) {
    this.initialise();
  },
  created(this: any) {
    this.templateSigningPartyFieldTypes = [
      {
        value: ScriveSigningPartyFieldType.Signature,
        text: 'Signature'
      },
      {
        value: ScriveSigningPartyFieldType.SignatureDate,
        text: 'Date'
      }
    ];
  },
  components: {
    LoadingSpinner,
    MStoreTable,
    MStoreFormGroup,
    MStoreFormRadioButtonGroup
  }
});
